<template>
  <div class="home-page container">
    <user-month-report @date-changed="updateUrl" :key="$route.params.year + '-' + $route.params.month + '-' + $route.params.day" :user_id="$get('auth/currentUser').id" :year="$route.params.year" :month="$route.params.month" :day="$route.params.day"/>
  </div>
</template>

<script>
import UserMonthReport from "./Reports/UserMonthReport";

export default {
  name: 'Home',

  components: {
    UserMonthReport
  },

  data() {
    return {
    }
  },

  computed: {
  },

  mounted() {
    if(this.$api.isMobile()) this.$router.replace({name: "tree"});
  },


  methods: {
    updateUrl(selected) {
      if(!this.$api.isMobile()) this.$router.push({name: 'home', params: {year: selected.year, month: selected.month, day: selected.day}}).catch(() => {});
    }
  }

}
</script>


<style lang="scss">

.home-page {
  margin-top:10px;
}


</style>
